import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
} from '../../../themes'
import { colorThemeSelector } from '../../../helpers'
const padding = 70
export const StyleModal = styled.div`
  .div-Modal{
    background: #000000;
    border: 1px solid ${COLOR.GRAY_10};
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left:0;
    opacity: 0.7;
    z-index: ${Z_INDEXS.LV_5};
  }
  .sub-content {
    padding: 60px;
  }
  .content-Modal{
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_6};
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    top: 20%;
    height: 420px;
    width: ${660 - padding}px;
    font-size: ${FONT_SIZE.SM};
    padding-left: ${padding}px;
    padding-right: ${padding}px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }


  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  .head-modal{
    font-family: 'LibreBaskerville-Bold';
    font-size: ${FONT_SIZE.XXL};
    letter-spacing: 1px;
    width: 520px; 
    margin-left: -13px;
  }

  .description{
    margin-top: 30px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }

  .description-email{
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }

  .input-email{
    margin-top: 50px;
    border: none;
    width: 100%;
    outline: none;
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    ::placeholder {
      font-size: ${FONT_SIZE.XS};
      color: ${COLOR.GRAY_3}
    }
  }

  .modal-btn-back, .modal-btn-send{
    width: 196px;
    margin-top: 30px;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GRAY_6};
    background: ${COLOR.WHITE};
    color: ${COLOR.BLACK_1};
  }

  .modal-btn-back {
    border: 1px solid ${COLOR.GRAY_19};
    background: ${COLOR.WHITE};
    color: ${COLOR.BLACK_1};
    font-family: NunitoSansRegular;
  }

  .modal-btn-send{
    border: 1px solid ${COLOR.PEARL_2};
    background: ${COLOR.PEARL_2};
    margin-left: 10px;
    color: ${COLOR.WHITE};
    cursor: not-allowed;
    float: right;
    font-family: NunitoBold;
  }

  .modal-btn-done {
    width: 196px;
    margin-top: 60px;
    margin-left: 140px;
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GOLD_1};
    background: ${COLOR.GOLD_1};
    color: ${COLOR.BLACK_1};
    cursor: pointer;
  }

  .is-pass {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
    cursor: pointer;
  }

  .text-error{
    text-align: left;
    margin-top: 8px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.RED_2};
  }

`
